<div class="lg-page">
  <div class="lg-container">

    <header class="lg-header">
      <span class="lg-brand">SEHYOG ACADEMY</span>
      <h1 class="lg-title">Privacy Policy</h1>
      <p class="lg-tagline">How Sehyog Academy collects, uses, and protects your personal information.</p>
      <p class="lg-meta">
        Effective date: {{ effectiveDate }}
        <span class="lg-dot">&bull;</span>
        Applies to: sehyog.co.uk and all associated booking, tuition and mock-test services
      </p>
      <div class="lg-rule"></div>
    </header>

    <section class="lg-section" *ngFor="let sec of sections">
      <h2 class="lg-heading" *ngIf="sec.title">{{ sec.number }}. {{ sec.title }}</h2>

      <h3 class="lg-subheading" *ngIf="sec.subheading">{{ sec.subheading }}</h3>

      <p class="lg-para" *ngFor="let p of sec.paragraphs" [innerHTML]="p"></p>

      <ul class="lg-bullets" *ngIf="sec.bullets && sec.bullets.length">
        <li *ngFor="let b of sec.bullets" [innerHTML]="b"></li>
      </ul>
    </section>

    <p class="lg-footnote">
      This policy should be read alongside our Terms &amp; Conditions and our Payment &amp; Refund Policy.
    </p>

  </div>
</div>
